import Styles from './SEOPlanningWizard.module.scss'
import Table from 'components/BlazeTable/BlazeTable'
import { LineSkeleton } from 'components/Skeleton/LineSkeleton'
import { Checkbox } from 'components/Form/Checkbox/Checkbox'
import { RadioBullet } from 'components/RadioGroup/RadioBullet'

const KeywordLoadingRow = ({ isCheckbox }: { isCheckbox: boolean }) => {
  return (
    <Table.Tr>
      <Table.Td>
        <div className={Styles.keywordCell}>
          {isCheckbox ? <Checkbox size="lg" isDisabled /> : <RadioBullet isDisabled />}
          <LineSkeleton className={Styles.keywordShimmer} />
        </div>
      </Table.Td>
      <Table.Td maxWidth="148px">
        <LineSkeleton className={Styles.keywordShimmer} />
      </Table.Td>
      <Table.Td maxWidth="66px">
        <LineSkeleton className={Styles.keywordShimmer} />
      </Table.Td>
    </Table.Tr>
  )
}

export const KeywordsLoadingState = ({ isCheckbox = false }: { isCheckbox?: boolean }) => {
  return (
    <>
      {Array(5)
        .fill(null)
        .map((_, index) => (
          <KeywordLoadingRow key={index} isCheckbox={isCheckbox} />
        ))}
    </>
  )
}
